import { Component, OnInit, Input } from '@angular/core';
import { title } from 'process';

@Component({
  selector: 'app-card-standalone',
  templateUrl: './card-standalone.component.html',
  styleUrls: ['./card-standalone.component.less'],
})
export class CardStandaloneComponent implements OnInit {
  @Input() title: string;

  constructor() {}

  ngOnInit(): void {}
}
